import axios from "axios";
import { baseURL } from "../../../Config/axios";

export const ProjectDetailsFn = async (id) => {
  try {
    const storedUser = localStorage.getItem("authentication");

    const userObject = storedUser ? JSON.parse(storedUser) : null;

    const response = await axios.get(baseURL + "/blog/projectlist-api/", {
      params: {
        project_id: id,
      },

      headers: {
        Authentication: userObject?.token,
      },
    });

    return response || [];
  } catch (e) {
    console.log(e);
  }
};
